/**
 * @author caijianjia
 * @date 2020/4/26 4:31 下午
 */
export const tableHead = [{
  prop: 'name',
  label: '课时名称',
  width: '180',
}, {
  prop: 'title',
  label: '课时标题',
  width: '180',
}, {
  prop: 'unit_name',
  label: '所属单元',
}, {
  prop: 'knowledge_content',
  label: '教学知识点',
}, {
  prop: 'created_at',
  label: '创建时间',
},
{
  prop: 'updated_at',
  label: '更新时间',
},
{
  prop: 'sales_status_text',
  label: '状态',
}];

export const tableData = [];



// WEBPACK FOOTER //
// ./src/views/Goods/editClass/fields.js